<template>
  <div class="container mx-auto px-4 py-8 max-w-4xl">
    
    <div class="max-w-3xl mx-auto px-4 py-10">
    <h1 class="text-3xl font-bold mb-6">Kebijakan Privasi</h1>

    <p class="mb-4 text-gray-500">Terima kasih telah mengunjungi <strong>Ngopi.di-mana.com</strong>, direktori kafe lengkap untuk wilayah Jawa dan Bali. Kami menghargai privasi Anda dan berkomitmen untuk melindungi informasi yang Anda berikan.</p>

    <h2 class="text-xl font-semibold mt-6 mb-2">Informasi yang Kami Kumpulkan</h2>
    <p class="mb-4 text-gray-500">Kami tidak mengumpulkan data pribadi seperti nama, alamat email, atau informasi identitas lainnya secara langsung dari pengguna. Namun, kami menggunakan Google Tag Manager untuk mengumpulkan data aktivitas pengguna di situs kami, seperti halaman yang dikunjungi dan interaksi dengan konten. Data ini bersifat anonim dan digunakan untuk memahami bagaimana pengguna menggunakan situs kami agar kami dapat meningkatkan pengalaman Anda.</p>

    <h2 class="text-xl font-semibold mt-6 mb-2">Penggunaan Data</h2>
    <p class="mb-4 text-gray-500">Data aktivitas yang dikumpulkan melalui Google Tag Manager hanya digunakan untuk analisis internal dan peningkatan layanan. Kami tidak menjual, menyewakan, atau membagikan data ini kepada pihak ketiga untuk tujuan pemasaran.</p>

    <h2 class="text-xl font-semibold mt-6 mb-2">Cookies dan Teknologi Serupa</h2>
    <p class="mb-4 text-gray-500">Ngopi.di-mana.com dapat menggunakan cookies dan teknologi serupa untuk mendukung pengumpulan data aktivitas pengguna melalui Google Tag Manager. Anda dapat mengatur preferensi cookie melalui pengaturan browser Anda.</p>

    <h2 class="text-xl font-semibold mt-6 mb-2">Keamanan Data</h2>
    <p class="mb-4 text-gray-500">Kami berkomitmen untuk menjaga keamanan data aktivitas yang kami kumpulkan dengan menggunakan langkah-langkah teknis dan organisasi yang sesuai.</p>

    <h2 class="text-xl font-semibold mt-6 mb-2">Perubahan Kebijakan Privasi</h2>
    <p class="mb-4 text-gray-500">Kami dapat memperbarui kebijakan privasi ini dari waktu ke waktu. Perubahan akan diumumkan di halaman ini.</p>

    <h2 class="text-xl font-semibold mt-6 mb-2">Hubungi Kami</h2>
    <p class="mb-8 text-gray-500">Jika Anda memiliki pertanyaan mengenai kebijakan privasi ini, silakan hubungi kami melalui email di: <a href="mailto:info-ngopi@di-mana.com" class="text-gray-700 font-semibold hover:underline">info-ngopi@di-mana.com</a>.</p>

    <p class="text-gray-800">Untuk informasi mengenai kepemilikan konten, penggunaan data pihak ketiga, dan tanggung jawab situs web, silakan merujuk ke <a href="/disclaimer" class="text-gray-700 font-semibold hover:underline">Disclaimer</a>.</p>

    <hr class="my-10 border-t" />

    <h1 class="text-3xl font-bold mb-6">Privacy Policy</h1>

    <p class="mb-4 text-gray-500">Thank you for visiting <strong>Ngopi.di-mana.com</strong>, a comprehensive cafe directory for Java and Bali. We respect your privacy and are committed to protecting any information you provide.</p>

    <h2 class="text-xl font-semibold mt-6 mb-2">Information We Collect</h2>
    <p class="mb-4 text-gray-500">We do not collect personal data such as names, email addresses, or other personally identifiable information directly from users. However, we use Google Tag Manager to collect user activity data on our website, such as pages visited and interactions with content. This data is anonymous and used solely to understand how users engage with our site to improve your experience.</p>

    <h2 class="text-xl font-semibold mt-6 mb-2">Use of Data</h2>
    <p class="mb-4 text-gray-500">The activity data collected via Google Tag Manager is used only for internal analytics and service improvement. We do not sell, rent, or share this data with third parties for marketing purposes.</p>

    <h2 class="text-xl font-semibold mt-6 mb-2">Cookies and Similar Technologies</h2>
    <p class="mb-4 text-gray-500">Ngopi.di-mana.com may use cookies and similar technologies to facilitate the collection of user activity data through Google Tag Manager. You can manage your cookie preferences through your browser settings.</p>

    <h2 class="text-xl font-semibold mt-6 mb-2">Data Security</h2>
    <p class="mb-4 text-gray-500">We are committed to protecting the security of the activity data we collect by implementing appropriate technical and organizational measures.</p>

    <h2 class="text-xl font-semibold mt-6 mb-2">Changes to This Privacy Policy</h2>
    <p class="mb-4 text-gray-500">We may update this privacy policy from time to time. Any changes will be posted on this page.</p>

    <h2 class="text-xl font-semibold mt-6 mb-2">Contact Us</h2>
    <p class="mb-4 text-gray-500">If you have any questions about this privacy policy, please contact us at: <a href="mailto:info-ngopi@di-mana.com" class="text-gray-700 font-semibold hover:underline">info-ngopi@di-mana.com</a>.</p>

    <p class="text-gray-800">For information regarding content ownership, third-party data usage, and website responsibility, please refer to our <a href="/disclaimer" class="text-gray-700 font-semibold hover:underline">Disclaimer</a>.</p>
  </div>
  </div>
</template>

<script setup lang="ts">
import { useSeo } from '../composables/useSeo'

// Set SEO metadata
useSeo({
  title: 'Kebijakan Privasi | Ngopi di Mana?',
  description: 'Kebijakan privasi Ngopi di Mana — cara kami mengumpulkan, menggunakan, dan melindungi informasi pengguna.',
  type: 'website',
  url: 'https://ngopi.di-mana.com/privacy-policy',
})
</script>

<style lang="postcss" scoped>
/* Add any component-specific styles here */
</style>